/**
 * NCB (Native Container Backend) 
 * Persistence Layer for R. Venue Apartelle
 * Finalized: 12-image set synchronized for Website and Admin Dashboard.
 */

const STORAGE_KEYS = {
  GALLERY: 'rvenue_gallery_v11',
  BLOCKED_DATES: 'rvenue_blocked_dates_v1',
  REVIEWS: 'rvenue_reviews_v1',
  BOOKINGS: 'rvenue_bookings_v1'
};

const INITIAL_DATA = {
  gallery: [
    { 
      id: '1', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/ed97c67b1eaae9a55591fe6f74b16510.jpeg', 
      alt_text: 'Premium Suite Bedroom', 
      span_class: 'md:col-span-2 md:row-span-2', 
      display_order: 1 
    },
    { 
      id: '2', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/78c6a8d315e321ead0b34ce434f34a27.jpg', 
      alt_text: 'Spacious Living Area', 
      span_class: '', 
      display_order: 2 
    },
    { 
      id: '3', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/1db3688b73283a152a22b2aaaa34eab8.png', 
      alt_text: 'Mountain View Balcony', 
      span_class: 'md:col-span-1 md:row-span-2', 
      display_order: 3 
    },
    { 
      id: '4', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/79a3fba6fee332af15b17853be4cc42e.jpeg', 
      alt_text: 'Comfortable Bed Detail', 
      span_class: '', 
      display_order: 4 
    },
    { 
      id: '7', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/3f062d6a43249321829adf3829f991dd.png', 
      alt_text: 'Welcome Reception', 
      span_class: '', 
      display_order: 6 
    },
    { 
      id: '8', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/fa08320d2b30ae5b48e8e295f5f42373.png', 
      alt_text: 'Kitchen & Water Dispenser', 
      span_class: '', 
      display_order: 7 
    },
    { 
      id: '9', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/623a75226bcb1faf3d8ca420c99f46d0.png', 
      alt_text: 'Kitchen Appliances', 
      span_class: '', 
      display_order: 8 
    },
    { 
      id: '10', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/232f9a9dff94806349d46bbcf1408d49.jpg', 
      alt_text: 'Cozy Bed Detail', 
      span_class: '', 
      display_order: 9 
    },
    { 
      id: '11', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/75d378550ba50e09b945c0f308c0db11.jpg', 
      alt_text: 'Dining Table Setup', 
      span_class: '', 
      display_order: 10 
    },
    { 
      id: '12', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/4ffc75e0b5c4ccfed8b3d98ba5281aa2.jpg', 
      alt_text: 'Full Room View', 
      span_class: 'md:col-span-2', 
      display_order: 11 
    },
    { 
      id: '13', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/2550cc0f0352006e40a68debef845fbb.jpeg', 
      alt_text: 'Festival Street View', 
      span_class: 'md:col-span-2', 
      display_order: 12 
    },
    { 
      id: '14', 
      url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvanBlZw==/04917f60ba1d63e3e8194d529fae979b.jpg', 
      alt_text: 'Balcony Seating Area', 
      span_class: '', 
      display_order: 13 
    }
  ],
  reviews: [
    { id: '1', guest_name: 'Rhona', role: '12 years on Airbnb', content: 'The place was well-maintained and comfortable. The entire transaction was pleasant and hassle-free. Thank you for a great stay.', rating: 5, is_featured: true, image_url: 'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?q=80&w=200&auto=format&fit=crop' },
    { id: '2', guest_name: 'Jm', role: '8 years on Airbnb', content: "The location of the establishment is great. Its right smack in the center of the old town proper, fronting a quaint open space - Plaza Rizal. The place is very spacious! And the offered amenities/facilities are all working.", rating: 5, is_featured: true, image_url: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?q=80&w=200&auto=format&fit=crop' },
    { id: '3', guest_name: 'Jay Paul', role: '5 years on Airbnb', content: 'Excellent location. Feels like home. Highly recommended!', rating: 5, is_featured: true, image_url: 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?q=80&w=200&auto=format&fit=crop' },
    { id: '4', guest_name: 'Maria Santos', role: 'Family Traveler', content: 'What a hidden gem! The apartelle is beautifully designed with a very calming atmosphere.', rating: 5, is_featured: true, image_url: 'https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/db2ec9b8b921c7f48ae02714d80c7c2c.png' }
  ],
  bookings: [
    { id: '1', guest_name: 'Juan Dela Cruz', email: 'juan@example.com', check_in: '2024-05-14', check_out: '2024-05-16', status: 'confirmed', guests: 2, total: '₱5,000' },
    { id: '2', guest_name: 'Maria Clara', email: 'maria@gmail.com', check_in: '2024-05-20', check_out: '2024-05-22', status: 'pending', guests: 3, total: '₱7,500' }
  ],
  blocked_dates: []
};

const ncb = {
  _get: (key, defaultData = []) => {
    const data = localStorage.getItem(key);
    if (!data) {
      localStorage.setItem(key, JSON.stringify(defaultData));
      return defaultData;
    }
    return JSON.parse(data);
  },

  _set: (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  },

  gallery: {
    list: () => ncb._get(STORAGE_KEYS.GALLERY, INITIAL_DATA.gallery).sort((a,b) => a.display_order - b.display_order),
    add: (item) => {
      const current = ncb.gallery.list();
      const newItem = { ...item, id: crypto.randomUUID(), created_at: new Date().toISOString() };
      ncb._set(STORAGE_KEYS.GALLERY, [...current, newItem]);
      return newItem;
    },
    delete: (id) => {
      const current = ncb.gallery.list();
      ncb._set(STORAGE_KEYS.GALLERY, current.filter(item => item.id !== id));
    }
  },

  availability: {
    list: () => ncb._get(STORAGE_KEYS.BLOCKED_DATES, INITIAL_DATA.blocked_dates),
    toggle: (dateStr) => {
      const current = ncb.availability.list();
      const exists = current.find(d => d.date === dateStr);
      if (exists) {
        ncb._set(STORAGE_KEYS.BLOCKED_DATES, current.filter(d => d.date !== dateStr));
      } else {
        ncb._set(STORAGE_KEYS.BLOCKED_DATES, [...current, { date: dateStr, id: crypto.randomUUID() }]);
      }
      return !exists;
    }
  },

  reviews: {
    list: () => ncb._get(STORAGE_KEYS.REVIEWS, INITIAL_DATA.reviews),
    add: (review) => {
      const current = ncb.reviews.list();
      const newReview = { ...review, id: crypto.randomUUID(), created_at: new Date().toISOString() };
      ncb._set(STORAGE_KEYS.REVIEWS, [newReview, ...current]);
      return newReview;
    },
    delete: (id) => {
      const current = ncb.reviews.list();
      ncb._set(STORAGE_KEYS.REVIEWS, current.filter(r => r.id !== id));
    }
  },

  bookings: {
    list: () => ncb._get(STORAGE_KEYS.BOOKINGS, INITIAL_DATA.bookings),
    add: (booking) => {
      const current = ncb.bookings.list();
      const newBooking = { ...booking, id: crypto.randomUUID(), created_at: new Date().toISOString() };
      ncb._set(STORAGE_KEYS.BOOKINGS, [newBooking, ...current]);
      return newBooking;
    }
  }
};

export default ncb;